import { Card } from 'antd';

import MeasurementsTable from '../../../components/Measurements';

function Measurements() {
  return (
    <Card>
      <MeasurementsTable breadcrumb="List of Livestock measures" title="Livestock measures" />
    </Card>
  );
}

export default Measurements;
